import React from "react";
import { Box, Typography } from "@mui/material";
import type { TypographyProps } from "@mui/material";

interface PageHeaderTitleProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  titleVariant?: TypographyProps["variant"];
  children?: React.ReactNode;
}

const PageHeaderTitle: React.FC<PageHeaderTitleProps> = ({
  icon,
  title,
  subtitle,
  titleVariant = "h4",
  children,
}) => {
  const iconSize = titleVariant === "h5" ? 24 : 28;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: subtitle ? 0.5 : 0,
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            color: "primary.main",
            display: "inline-flex",
            alignItems: "center",
            "& svg": { fontSize: iconSize },
          }}
        >
          {icon}
        </Box>
        <Typography variant={titleVariant} fontWeight={700}>
          {title}
        </Typography>
        {children}
      </Box>
      {subtitle && (
        <Typography
          variant={titleVariant === "h5" ? "body2" : "body1"}
          color="text.secondary"
          sx={{ display: { xs: "none", sm: "block" } }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeaderTitle;
